import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import Modal from 'react-modal';
import classNames from 'classnames';

import * as _actions from '../../actions';
import * as _actionsJourney1 from '../../actions/journey1';
import * as _actionsJourney2 from '../../actions/journey2';
import * as _actionsBasket from '../../actions/basket';
import * as _actionsProduct from '../../actions/product';
import * as _actionsFilters from '../../actions/filters';
import { RootState } from '../../reducers';
import { isComingFromJ2, renderSwitch } from '../../utils/react';
import { getParameterByName } from '../../utils/toSearchParams';
import { EMPTY_VALIDATION_MESSAGE_CONFIG } from '../../components/ValidationMessage';
import ProgressBar from '../../components/ProgressBarV2';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';
import Step6 from './Step6';
import Step7 from './Step7';
import Summary from '../Summary';
import './Journey1.scss';
import BreadCrumbs from '../../components/BreadCrumbs';
import RouterContext from '../RouterContext';
import SpinnerV2 from '../../components/SpinnerV2';
import Page404 from '../Page404';
import { useParams } from 'react-router-dom';
import Basket from '../../components/Basket';
import { ModalContainer } from '../../components/ModalContainer';
import OrderConfirmation from '../OrderConfirmation';
import { LoginRequired } from '../../components/ProtectedComponent';
import { PartiallyIntegratedUserDataEC } from '../../reducers/app';
import { SchemaProduct, SchemaPossibleBookingDates } from '@repo/legacy-commerce-api';

Modal.setAppElement('#root');

interface Props {
  actions: typeof _actions;
  actionsJourney: typeof _actionsJourney1;
  actionsJourney2: typeof _actionsJourney2;
  actionsBasket: typeof _actionsBasket;
  actionsProduct: typeof _actionsProduct;
  actionsFilters: typeof _actionsFilters;
  baskets: any;
  big5Industries: any;
  filters: any;
  history: any;
  industries: any;
  intl: any;
  isDrawRadius: boolean;
  keycloakReady: any;
  loading: { general: boolean };
  errors: any;
  location: any;
  match: any;
  nextProduct: (SchemaProduct & { idx: number }) | null;
  possibleBookingDates: SchemaPossibleBookingDates;
  prevProduct: (SchemaProduct & { idx: number }) | null;
  product: any;
  startDate: Date;
  urlHistory: any;
  productsJ2: SchemaProduct[];
  productsJ2ByUrn: Record<string, SchemaProduct>;
  userDataEC: PartiallyIntegratedUserDataEC;
}

const Journey1 = (props: Props) => {
  const [currentlyVisibleProduct, setCurrentlyVisibleProduct] = React.useState(
    getParameterByName('urn', props.location.search),
  );

  const [readyToRender, setReadyToRender] = React.useState(false);

  const params = useParams();

  useEffect(() => {
    if (isComingFromJ2(props.urlHistory)) {
      props.actions.clearData('basket');
    }
    (window as any).gApiLoaded = new Event('gApiLoaded');
    (window as any).addEventListener('gApiLoaded', scriptLoaded);

    if (props.keycloakReady) {
      preFetchData();
    }
    return () => {
      window.removeEventListener('gApiLoaded', scriptLoaded);
    };
  }, [props.keycloakReady]);

  // componentDidUpdate(prevProps, prevState, snapshot) {
  //     const {
  //         userDataEC: { industry },
  //         match,
  //         keycloakReady,
  //     } = this.props;
  //
  //     const prevStep = prevProps.match.params.step;
  //     const step = match.params.step;
  //
  //     this.fetchProduct();
  //
  //     if (keycloakReady && keycloakReady !== prevProps.keycloakReady) {
  //         this.preFetchData();
  //     }
  //
  //     if (step < prevStep && step <= this.checkoutStep) {
  //         this.cancelOrConfirmBasket();
  //     }
  //
  //     if (prevProps.userDataEC.industry !== industry && industry) {
  //         this.informAboutChangingIndustry();
  //     }
  //
  //     // For django page
  //     if (this.props.match.params.step !== prevProps.match.params.step && this.props.match.params.step > 1) {
  //         window.scrollTo({ top: 0, behavior: 'smooth' });
  //     }
  // }

  const scriptLoaded = () => {
    setReadyToRender(true);
  };

  const fetchProduct = (force?) => {
    const currentUrn = getParameterByName('urn', props.location.search);
    if (currentlyVisibleProduct != currentUrn || force) {
      if (currentUrn && props.userDataEC?.chosenBasketProducts?.products?.length > 0) {
        setCurrentlyVisibleProduct(currentUrn);
        props.actionsProduct.fetchProducts({ urn: currentUrn });
      }
    }
  };

  const preFetchData = () => {
    props.actionsFilters.fetchBookingDates();

    let extraParam = null;
    if (props.userDataEC.basketInfo) {
      extraParam = {
        basket: props.userDataEC.basketInfo?.basket,
        basketreference: props.userDataEC.basketInfo?.basketreference,
      };
    }
    props.actionsFilters.fetchIndustries({ context: 'big5', ...extraParam });
    props.actionsFilters.fetchIndustries({ context: 'alcohol', ...extraParam });

    // @ts-expect-error properties of "state" don't match number vs union type:
    props.userDataEC.basketInfo && props.actionsJourney.getBasketContent(props.userDataEC.basketInfo);
  };

  const validationMessageConfig = (inputName, defaultValidationMessageConfig, validationTests) => {
    return defaultValidationMessageConfig || EMPTY_VALIDATION_MESSAGE_CONFIG;
  };

  const step = Number(params.step);

  return (
    <>
      <BreadCrumbs
        parentPage={props.intl.formatMessage({
          id: 'ec.navigation.planenbuchen',
          defaultMessage: 'Planen und Buchen',
        })}
        pageName={props.intl.formatMessage({
          id: 'ec.navigation.journey1PageName',
          defaultMessage: 'Flächenauswahl',
        })}
      />
      <div className='container-fluid overflow-hidden journey1 p-0'>
        <div className='pageContainer'>
          <ModalContainer
            actionsBasket={_actionsBasket}
            location={props.location}
            actionsJourney2={_actionsJourney2}
            userDataEC={props.userDataEC}
            actionsProduct={_actionsProduct}
            errors={props.errors}
            intl={props.intl}
            loading={props.loading}
            product={props.product}
            productsJ2={props.productsJ2}
            productsJ2ByUrn={props.productsJ2ByUrn}
          />

          <Basket
            products={props.userDataEC.basketProducts.products}
            total={props.userDataEC.basketProducts.stats?.mediasum}
          />

          {step <= 11 && <ProgressBar step={step} journeyType={'journey1'} />}
          <RouterContext.Provider value={props.history}>
            <div
              className={classNames('contentContainer', {
                perc10: step == 1,
                perc20: step == 2,
                perc30: step == 3,
                perc40: step == 4,
                perc50: step == 5,
                perc60: step == 6,
                perc70: step == 7,
                perc80: step == 8,
                perc90: step == 9,
                perc100: step == 10,
                perc110: step == 11,
              })}
            >
              <SwitchTransition mode='out-in'>
                <CSSTransition
                  key={params.step}
                  timeout={{
                    enter: 1000,
                    exit: 500,
                  }}
                  classNames='fade'
                >
                  <div className={classNames('main', { full: step == 7 })}>
                    {props.keycloakReady ? (
                      renderSwitch(
                        step,
                        {
                          1: () => <Step1 />,
                          2: () => <Step2 readyToRender={readyToRender} />,
                          3: () => <Step3 />,
                          4: () => <Step4 />,
                          5: () => <Step5 />,
                          6: () => <Step6 validationMessageConfig={validationMessageConfig} />,
                          7: () => <Step7 fetchProduct={fetchProduct} />,
                          8: () => <LoginRequired component={<Summary />} />,
                          9: () => <LoginRequired component={<OrderConfirmation />} />,
                        },
                        () => <Page404 />,
                      )
                    ) : (
                      <SpinnerV2 relative fullScreen />
                    )}
                  </div>
                </CSSTransition>
              </SwitchTransition>
            </div>
          </RouterContext.Provider>
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    actions: bindActionCreators(_actions as any, dispatch),
    actionsJourney: bindActionCreators(_actionsJourney1 as any, dispatch),
    actionsJourney2: bindActionCreators(_actionsJourney2 as any, dispatch),
    actionsBasket: bindActionCreators(_actionsBasket as any, dispatch),
    actionsProduct: bindActionCreators(_actionsProduct as any, dispatch),
    actionsFilters: bindActionCreators(_actionsFilters as any, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Journey1);
